<template>
    <span v-html="title">
    </span>
</template>

<script>
    export default {
        props: [
            'text'
        ],
        data() {
            return {
            }
        },
        computed: {
            title() {
                let titles = _.slice(
                    _.split(this.text, '\n'),
                    1
                );
                return  _.join(titles, '<br>');
            }
        }
    }
</script>
